import clsx from 'clsx';
import React from 'react';

import Spinner from '@/src/components/common/Elements/Spinner/Spinner';
import ModalPortal from '@/src/components/common/Modal/ModalPortal';
import NotAvailable from '@/src/components/notAvailable';
import { BASE_HASH_PATH, generateRoutePath } from '@/src/routes';

import EmailEntryViewer from './EmailEntryViewer/EmailEntryViewer';
import Header from './Header/Header';

import { useMappedEmailEntry } from '../../../components/EntryPanel/EmailThreadEntryViewer/components/EmailThreadViewer/EmailEntries/EmailEntry/useMappedEmailEntry';
import { EmailThreadEntryViewerProvider } from '../../../components/EntryPanel/EmailThreadEntryViewer/store/emailThreadEntryViewer.store';
import { INBOX_ENTRY_VIEWER_PAGES_PATH } from '../../../Config/inbox.routes';
import { InboxEntrySource, InboxEntryType } from '../../../types';
import { useProjectDetails } from '../../useProject';

export const getEmailEnryViewerPageUrl = ({
  projectId,
  inboxEntryId,
  emailId,
  fileId,
}: {
  projectId: string;
  inboxEntryId: number;
  emailId: string;
  fileId?: string;
}) => {
  return (
    window.location.origin +
    BASE_HASH_PATH +
    generateRoutePath(
      INBOX_ENTRY_VIEWER_PAGES_PATH,
      {
        projectId,
        inboxEntryId,
      },
      {
        type: InboxEntryType.THREAD.toLowerCase(),
        source: InboxEntrySource.Email,
        emailId,
        ...(fileId ? { fileId } : {}),
      }
    )
  );
};

type EmailEntryViewerPageProps = {
  projectId: string;
  inboxEntryId: number;
  emailId: number;
  fileId?: number;
};

const EmailEntryViewerPage = ({
  emailId,
  projectId,
  inboxEntryId,
  fileId,
}: EmailEntryViewerPageProps) => {
  const { project } = useProjectDetails();
  const { emailEntry, emailEntryQueryData } = useMappedEmailEntry({
    emailId,
    projectId,
    inboxEntryId,
  });

  if (emailEntryQueryData && emailEntryQueryData.status !== true) {
    return <NotAvailable />;
  }

  if (!emailEntry || !project) {
    return <Spinner />;
  }

  return (
    <EmailThreadEntryViewerProvider>
      <ModalPortal isEnabled={true}>
        <div
          className={clsx(
            'emailUrlPage--container',
            'card--selectedEntryPanel',
            'tw-px-[20px] tw-py-0 tw-mt-[20px]',
            'tw-w-full',
            'tw-overflow-auto tw-scroll-styles',
            'tw-absolute tw-inset-0 tw-z-[3]',
            'tw-bg-white'
          )}
        >
          <Header emailEntry={emailEntry} projectName={project.project} projectId={projectId} />
          <EmailEntryViewer
            emailEntry={emailEntry}
            projectId={projectId}
            preselectedFileId={fileId}
          />
        </div>
      </ModalPortal>
    </EmailThreadEntryViewerProvider>
  );
};

export default EmailEntryViewerPage;
